/**
 * Version du site (21/10/2026), posée au build par vite.config (tag git).
 * Discrète : une ligne de légende, utile au support et à la recette.
 */
export const VERSION_APP: string = import.meta.env.VITE_APP_VERSION || 'dev';

export function VersionApp({ produit }: { produit: string }) {
  return (
    <p
      className="version-app"
      style={{ fontSize: '0.75rem', opacity: 0.6, textAlign: 'center', margin: '1.5rem 0 0' }}
    >
      {produit} {VERSION_APP}
    </p>
  );
}
